(function () {
  const hero = () => {
    const isRTL = getComputedStyle(document.body).direction === "rtl";
    const sections = document.querySelectorAll(".hero-section:not(.hero_initialized)");
    if (!sections.length) return;

    sections.forEach((section) => {
      const mediaWrapper  = section.querySelector(".hero_image-wrapper");
      const content       = section.querySelector(".hero_content-wrapper");
      const line          = section.querySelector(".hero_line");
      const tickerBox     = section.querySelector(".hero_ticker-box");
      const tickerWrapper = section.querySelector(".hero_ticker-wrapper");
      const tickerBlock   = section.querySelector(".hero_ticker-block");
      const tickerText    = tickerWrapper ? tickerWrapper.querySelector(".hero_ticker-text") : null;

      const isInViewport = (el) => {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom >= 0;
      };

      const calculateTransition = (word) => {
        const wordLength   = (word.textContent || "").trim().length;
        const baseDuration = 1500;
        const total        = baseDuration + wordLength * 50;
        const easing       = "cubic-bezier(.23, 1, .32, 1)";
        return { duration: `${total}ms`, easing };
      };

      // Reveal ticker words (scoped)
      const revealWords = () => {
        if (!tickerBox) return;
        const allTickers = tickerBox.querySelectorAll(".hero_ticker-text");
        if (!allTickers.length) return;

        let delayOffset = 0;
        allTickers.forEach((currentTicker) => {
          const wordElements = currentTicker.querySelectorAll(".ticker-word");
          wordElements.forEach((word, i) => {
            const { duration, easing } = calculateTransition(word);
            setTimeout(() => {
              word.style.transition = `transform ${duration} ${easing}`;
              word.classList.add("visible");
            }, delayOffset + i * 100);
          });
          delayOffset += wordElements.length * 100;
        });
      };

      // IntersectionObserver
      const io = ("IntersectionObserver" in window)
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              if (entry.target.classList.contains("hero_line")) {
                setTimeout(() => entry.target.classList.add("visible"), 500);
              } else {
                entry.target.classList.add("visible");
              }

              if (entry.target === tickerWrapper || entry.target.classList.contains("hero_ticker-box")) {
                revealWords();
              }
              io.unobserve(entry.target);
            });
          }, { threshold: 0.01 })
        : null;

      [content, line, tickerWrapper, tickerBox].forEach((el) => { if (io && el) io.observe(el); });

      // Media load handling
      if (mediaWrapper) {
        const image = mediaWrapper.querySelector("img");
        const video = mediaWrapper.querySelector("video");

        // Guard imagesLoaded optionality
        if (image) {
          if (typeof window.imagesLoaded === "function") {
            window.imagesLoaded(image, function () {
              image.classList.add("hero_media_loaded");
            });
          } else {
            // Fallback: mark as loaded on decode
            if (image.decode) {
              image.decode().catch(()=>{}).finally(() => image.classList.add("hero_media_loaded"));
            } else {
              image.addEventListener("load", () => image.classList.add("hero_media_loaded"), { once:true });
            }
          }
        }

        if (io) io.observe(mediaWrapper);
      }

      // Ticker build
      if (tickerWrapper && tickerText) {
        const originalText = (tickerText.textContent || "").trim().replace(/\s+/g, " ");
        const words = originalText ? originalText.split(" ") : [];

        tickerText.innerHTML = "";
        words.forEach((w) => {
          const el = document.createElement("span");
          el.classList.add("ticker-word");
          el.textContent = w + " ";
          tickerText.appendChild(el);
        });

        // Measure width safely; handle hidden/zero width
        // Force a reflow to get a stable offsetWidth even on Safari
        void tickerText.offsetWidth;
        let tickerWidth = tickerText.offsetWidth;

        // If width is 0 (hidden or not yet painted), use a safe fallback
        if (!Number.isFinite(tickerWidth) || tickerWidth < 1) {
          tickerWidth = Math.max(1, (originalText.length || 10) * 8); // approx char width
        }

        const screenWidth = 2 * window.innerWidth;
        let numberOfClones = Math.ceil(screenWidth / tickerWidth);
        if (!Number.isFinite(numberOfClones) || numberOfClones < 3) numberOfClones = 3;
        if (numberOfClones > 30) numberOfClones = 30; // sanity cap

        for (let i = 0; i < numberOfClones; i++) {
          const clone = tickerText.cloneNode(true);
          tickerWrapper.appendChild(clone);
        }

        // Per-section scroll handler
        let lastScrollY = window.scrollY;
        let currentTranslateX = 0;

        window.addEventListener("scroll", () => {
          if (!isInViewport(section)) return;

          const scrollDelta = window.scrollY - lastScrollY;
          let translateXValue = currentTranslateX - scrollDelta * 1;

          if (translateXValue > 0) translateXValue = 0;
          if (Math.abs(scrollDelta) > 0) {
            if (isRTL) translateXValue = -translateXValue;
            if (tickerBlock) tickerBlock.style.transform = `translateX(${translateXValue}px)`;
          }

          lastScrollY = window.scrollY;
          currentTranslateX = translateXValue;
        }, { passive: true });
      }

      section.style.opacity = "1";
      section.classList.add("hero_initialized");
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    hero();
    document.addEventListener("shopify:section:load", () => { hero(); });
  });
})();